import React from 'react';
import { FIGURES } from '../../content/whitepaper';

const pad = (n) => String(n).padStart(2, '0');

export function FigLabel({ n, label }) {
  return (
    <figcaption className="pp-fig__label">
      <span className="pp-fig__n">Fig. {n}</span>
      <span className="pp-fig__name">{label}</span>
    </figcaption>
  );
}

export function LoopFigure() {
  const { steps } = FIGURES.loop;
  return (
    <div className="fig-loop" role="img" aria-label="The loop: generate, decide, act, grade and train, then back to generate.">
      <ol className="fig-loop__steps">
        {steps.map(([name, output], i) => (
          <li key={name} className={`fig-box${name === 'Decide' ? ' fig-box--gate' : ''}`}>
            <span className="fig-box__n">{pad(i + 1)}</span>
            <span className="fig-box__name">{name}</span>
            <span className="fig-box__out">{output}</span>
          </li>
        ))}
      </ol>
      <div className="fig-loop__return" aria-hidden="true">
        <i />
        <i />
        <i />
      </div>
    </div>
  );
}

export function MoneyFigure({
  stages = FIGURES.money.stages,
  gate = 'Decision system',
  mark = 'Graded',
} = {}) {
  return (
    <div className="fig-money" role="img" aria-label={`${stages.join(', ')}. Each stage is ${mark.toLowerCase()}.`}>
      <ol className="fig-money__stages">
        {stages.map((stage) => (
          <li key={stage} className={`fig-box fig-box--flat${stage === gate ? ' fig-box--gate' : ''}`}>
            <span className="fig-box__name">{stage}</span>
          </li>
        ))}
      </ol>
      <div className="fig-money__graded" aria-hidden="true">
        <span>{mark}</span>
      </div>
    </div>
  );
}

export function GateFigure() {
  return (
    <div className="fig-gate" role="img" aria-label="Model output passes through the deterministic decision system, which contains no AI, before it reaches the market.">
      <div className="fig-box fig-box--ghost">
        <span className="fig-box__tag">Model output</span>
      </div>
      <div className="fig-box fig-box--gate fig-gate__system">
        <span className="fig-box__tag">Deterministic decision system</span>
        <span className="fig-box__name">Contains no AI · runs live</span>
        <span className="fig-box__out">Same inputs, same decision · every decision logged</span>
      </div>
      <div className="fig-box">
        <span className="fig-box__tag">Market</span>
      </div>
    </div>
  );
}

const ART = { loop: LoopFigure, money: MoneyFigure, gate: GateFigure };

export default function Figure({ kind, className = '' }) {
  const Art = ART[kind];
  const { n, label } = FIGURES[kind];
  return (
    <figure className={`pp-fig pp-fig--${kind} ${className}`.trim()}>
      <FigLabel n={n} label={label} />
      <div className="pp-fig__art">
        <Art />
      </div>
    </figure>
  );
}
